module.exports = __webpack_public_path__ + "img/image6.e7c6a1f.png";